class BannerCarousel {
  constructor(index, element, options) {
    this.$element = $(element);
    this.index = index;
    this.selectors = {
      wrapper: ".banner-carousel",
      slider: ".banner__wrapper",
      items: ".banner__slide",
      image: ".banner__image picture",
      nav: options.navigation,
      navCellSelector: options.navigationCellSelector,
      videoWrapper: ".mfr-components__video",
      video: ".mfr-components__video video",
      videoCover: ".mfr-components__video-cover",
      playButton: "[data-play-button]",
    };

    this.option = options.flickityOption;
    this.isDragging = false;

    this.initialize();
  }

  initialize() {
    this.$slider = this.$element.find(this.selectors.slider);
    this.$sliderNav = this.$element.find(this.selectors.nav);
    this.$items = this.$element.find(this.selectors.items);
    this.$videoWrapper = this.$element.find(this.selectors.videoWrapper);
    this.$video = this.$element.find(this.selectors.video);
    this.$videoCover = this.$element.find(this.selectors.videoCover);
    this.$playButton = this.$element.find(this.selectors.playButton);

    this.$playButton.on("click", this.__handlePlayButtonClick.bind(this));

    this.initMainSlider();
    this.initializeVideoEvents();
    this.initializeVideoFunctions();
    setTimeout(() => this.initializeNavSlider(), 100);
  }

  __handlePlayButtonClick(e) {
    let cell;
    if (this.$slider.data("flickity")) {
      cell = this.$slider.data("flickity").selectedElement;
    }
    else {
      cell = this.$videoWrapper;
    }
    if ( $(cell).find("video").hasClass("playing") ) {
      $(cell).find("video")[0].pause();
      $(cell).find("video").removeClass("playing");
    } else {
      $(cell).find("video")[0].play();
      $(cell).find("video").addClass("playing");
    }
  }

  initMainSlider() {
    if (this.$items.length <= 1) {
      this.$sliderNav.hide();
      return;
    }
    this.$slider.flickity({
      ...this.option,
      on: {
        select: () => this.pauseAllVideos(),
        dragStart: () => {
          this.isDragging = true;
        },
        dragEnd: () =>
          setTimeout(() => {
            this.isDragging = false;
          }, 100),
      },
    });
  }

  initializeNavSlider(data) {
    if (!this.$sliderNav.length) return;
    this.$sliderNav.flickity({
      asNavFor: this.$slider.get(0),
      cellSelector: this.selectors.navCellSelector,
      selectedAttraction: 0.1,
      friction: 0.55,
      prevNextButtons: true,
      contain: true,
      cellAlign: "left",
      pageDots: false,
      wrapAround: false,
      groupCells: false,
      freeScroll: false
    });
  }

  initializeVideoFunctions() {
    this.$videoWrapper.on("click", (e) => {
      if (this.isDragging) return;
      const videoEl = $(e.currentTarget).find("video").get(0);
      const videoElement = $(e.currentTarget).find("video");
      const videoCover = $(e.currentTarget).find(this.selectors.videoCover);

      if (videoEl.paused) {
        videoEl.play();
        videoElement.addClass("playing");
        // videoCover.fadeOut();
      } else {
        videoEl.pause();
        videoElement.removeClass("playing");
        // videoCover.fadeIn();
      }
    });
  }

  pauseAllVideos() {
    this.$video.each((i, e) => $(e).get(0).pause());
    this.$video.each((i, e) => $(e).removeClass('playing'));
  }

  initializeVideoEvents() {
    this.$video.on( "play", (e,i) => {
      $(e.currentTarget)
        .closest(this.selectors.videoWrapper)
        .find(this.selectors.videoCover)
        .fadeOut();

      this.$element
        .find(this.selectors.playButton)
        .removeClass( "play-button pause-button" )
        .addClass( "pause-button" );

      $(e.currentTarget)
        .closest(".banner__slide")
        .addClass("video-is-playing");
    } );
    this.$video.on( "pause", (e,i) => {
      $(e.currentTarget)
        .closest(this.selectors.videoWrapper)
        .find(this.selectors.videoCover)
        .fadeIn();

      this.$element
        .find(this.selectors.playButton)
        .removeClass("play-button pause-button")
        .addClass("play-button");

      $(e.currentTarget)
        .closest(".banner__slide")
        .removeClass("video-is-playing");
    } );
  }
}
